import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bell = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="M12.6804 6.39635C12.4166 4.28612 10.7897 2.64506 8.75 2.31198V1H7.25V2.30686C4.98126 2.66213 3.25 4.63858 3.25 7V8.29226L2.31123 9.85688C1.81134 10.69 2.41148 11.75 3.38309 11.75H12.6169C13.5885 11.75 14.1887 10.69 13.6888 9.85688L12.75 8.29226V6.95331L12.6804 6.39635ZM7.98347 3.75C6.20171 3.75 4.75 5.21016 4.75 7V8.70774L3.82464 10.25H12.1754L11.25 8.70774V7.04669L11.192 6.58241C10.9897 4.96428 9.61418 3.75 7.98347 3.75Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      d="M8.75 12.5C8.75 12.9142 8.41421 13.25 8 13.25C7.58579 13.25 7.25 12.9142 7.25 12.5H5.75C5.75 13.7426 6.75736 14.75 8 14.75C9.24264 14.75 10.25 13.7426 10.25 12.5H8.75Z"
      fill="currentColor"
    />
  </Icon>
));

export default Bell;
